import React from 'react';

// uses the stylesheets from the templates workspace, no need for these to be latest so implementation is much simpler than authenticated editor
const basePath = 'https://cdn.candu.ai/styleguides/applications/7CUNi8CatG/default';

interface StylesheetProps {
  children: any;
}

export const LaunchpadStylesheet = ({ children }: StylesheetProps) => {
  return (
    <>
      <div id="application-stylesheet">
        <link rel="stylesheet" href={`${basePath}/main.css`} />
      </div>
      <div id="application-fonts">
        <link rel="stylesheet" href={`${basePath}/fonts.css`} />
      </div>
      {children}
    </>
  );
};
